import { useEffect } from "react"

import { FlexContainer } from "../../../../styled/flexbox.styled"
import CollapsibleTagList from "../../../components/CollapsibleTagList"
import useTradingSectors from "../hooks/useTradingSectors"
import { SectorLevel } from "../types"
import { DatasetFilters } from "./types"

interface ISectorFilterProps {
  filters: DatasetFilters
  onFilterChange: (filters: { sectorsParam?: number[] }) => void
}

const SectorFilter = ({ filters, onFilterChange }: ISectorFilterProps) => {
  const { sectors } = useTradingSectors()

  useEffect(() => {
    onFilterChange({
      sectorsParam: filters.sectorsParam,
    })
  }, [filters, onFilterChange])

  return (
    <FlexContainer flexDirection="column" gap="10px">
      {Object.values(SectorLevel)
        .filter(value => typeof value === "number")
        .map((value, index) => {
          const level = value as SectorLevel
          return (
            <CollapsibleTagList
              key={index}
              title={`Sector Level ${level}`}
              items={sectors?.filter(sector => sector.level === level) ?? []}
              selectedItemIds={filters.sectorsParam
                ?.filter(sector => sectors?.find(s => s.id === sector)?.level === level)
                .map(sector => sector)}
              onItemToggle={item => {
                if (filters.sectorsParam?.includes(item.id)) {
                  onFilterChange({
                    sectorsParam: filters.sectorsParam?.filter(sector => sector !== item.id),
                  })
                } else {
                  onFilterChange({
                    sectorsParam: [...(filters.sectorsParam ?? []), item.id],
                  })
                }
              }}
              onClear={() => {
                onFilterChange({
                  sectorsParam: filters.sectorsParam?.filter(sectorId => {
                    // Find the sector object to check its level
                    const sectorObj = sectors?.find(s => s.id === sectorId)
                    // Keep only sectors that don't belong to this level
                    return sectorObj?.level !== level
                  }),
                })
              }}
            />
          )
        })}
    </FlexContainer>
  )
}

export default SectorFilter
